import { Tabs } from 'antd';
import {
	DashboardOutlined,
	AppstoreOutlined,
	DeleteOutlined,
} from '@ant-design/icons';
import Header from '../../../components/Header';
import DashboardTab from './DashboardTab';
import StagingAreasTab from './StagingAreasTab';
import DekitAreasTab from './DekitAreasTab';

const AdminPage = () => {
	const items = [
		{
			key: 'dashboard',
			label: (
				<span>
					<DashboardOutlined /> Dashboard
				</span>
			),
			children: <DashboardTab />,
		},
		{
			key: 'areas',
			label: (
				<span>
					<AppstoreOutlined /> Staging Areas
				</span>
			),
			children: <StagingAreasTab />,
		},
		{
			key: 'dekit',
			label: (
				<span>
					<DeleteOutlined /> Dekit Areas
				</span>
			),
			children: <DekitAreasTab />,
		},
	];

	return (
		<div className="w-full p-4">
			<Header title="Kit Tracking" />
			<Tabs defaultActiveKey="dashboard" items={items} />
		</div>
	);
};

export default AdminPage;
